<template>
  <div class="qa-list-container">
    <div class="qa-list-bar">
      <span>提问者列表</span>
      <div style="display:flex">
        <button class="qa-list-bar-button" @click="handleStopQa">
          <svg-icon class="qa-list-bar-button-icon" icon-class="qa-disable" />
          <span>关闭问答</span>
        </button>
      </div>
    </div>
    <div class="qa-list-content-wrap">
      <div class="qa-list-content">
        <div class="qa-list-content-title">
          <span class="name">姓名</span>
          <span class="phone">电话</span>
          <!-- <span class="adjust-order">调整顺序</span> -->
          <span class="operate">操作</span>
        </div>
        <template v-if="qaItemList.length === 0">
          <div class="qa-no-data">
            <svg-icon icon-class="no-data" />
            <span>无数据</span>
          </div>
        </template>
        <a-list v-else item-layout="horizontal">
          <VirtualList
            key-field="id"
            style="height: 600px"
            :items="qaItemList"
            :item-size="48"
            ref="virtualList"
            #default="{ items }"
          >
            <div v-for="item in items" :key="item.id">
              <div class="qa-list-content-item">
                <span class="name">
                  <span class="item-arrow">
                    <template
                      v-if="
                        item.__order > 1 || (!hasTalk && item.__order === 1)
                      "
                    >
                      <a-icon @click="handleMoveTopQa(item.id)" type="to-top" />
                      <a-icon
                        @click="handleMoveUpQa(item.id)"
                        type="arrow-up"
                      />
                    </template>
                  </span>
                  <span class="name-text" :title="item.name">{{
                    item.name
                  }}</span>
                  <svg-icon
                    class="qa-list-talk-icon"
                    :class="item.talk ? 'talk' : 'no-talk'"
                    :icon-class="item.talk ? 'talk' : 'no-talk'"
                  />
                </span>

                <span class="phone" :title="item.showPhone">{{
                  encryptTelEnable ? encryptTel(item.showPhone) : item.showPhone
                }}</span>

                <span class="operate">
                  <a-button
                    v-if="!item.talk"
                    @click="handlePromote(item.id)"
                    class="qa-list-talk-button"
                    >允许发言</a-button
                  >
                  <a-button
                    v-else
                    @click="handleMute(item.id)"
                    class="qa-list-talk-button qa-list-no-talk-button"
                    >停止发言并移出</a-button
                  >
                  <a-button
                    v-if="!item.talk"
                    icon="logout"
                    class="qa-list-quit-button"
                    @click="handleRemove(item.id)"
                    >移出问答</a-button
                  >
                </span>
              </div>
            </div>
          </VirtualList>
        </a-list>
      </div>
    </div>
  </div>
</template>

<script>
// import { RecycleScroller } from "vue-virtual-scroller";
// import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import VirtualList from "vue-virtualization-list";
import { mapState, mapGetters } from "vuex";
import {
  stopQa,
  removeQa,
  promoteQa,
  moveUpQa,
  moveTopQa
} from "@/services/qa";
import { custMute } from "@/model/conf/model";
export default {
  components: {
    VirtualList
  },
  computed: {
    ...mapState(["qaFloorParty", "qaList"]),
    ...mapGetters(["partyIdList", "encryptTelEnable"]),
    leng() {
      return this.data2.length;
    },
    data() {
      let i = 1;
      const data = this.data2.map(item => {
        item.id = i++;
        item.item = item.item + item.id;
        return item;
      });
      return data;
    },
    hasTalk() {
      return !!this.qaFloorParty;
    },
    qaItemList() {
      const qaList = [];
      console.log(this.partyIdList);
      console.log(this.qaList);
      if (this.qaFloorParty && this.partyIdList[this.qaFloorParty]) {
        const party = this.partyIdList[this.qaFloorParty];
        if (party) {
          const talk = !custMute(party.status);
          qaList.push({
            ...party,
            talk
          });
        }
      }
      this.qaList.forEach(id => {
        const party = this.partyIdList[id];
        if (party && id !== this.qaFloorParty) {
          const talk = !custMute(party.status);
          qaList.push({ ...party, talk });
        }
      });

      // for (let i = 1; i < 1000; i++) {
      //   qaList.push({ talk: false, name: i, showPhone: "123456", id: i });
      // }

      return qaList;
    }
  },
  data() {
    return {
      data2: []
    };
  },
  methods: {
    encryptTel(value) {
      return value.replace(
        this.$constReg.encryptTel.reg,
        this.$constReg.encryptTel.replace
      );
    },
    handlePromote(id) {
      promoteQa(id)
        .then(() => {})
        .catch(error => {
          console.log(error);
          this.$message.error(`允许发言请求失败。`);
        });
    },
    handleMute(id) {
      removeQa(id)
        .then(() => {})
        .catch(error => {
          console.log(error);
          this.$message.error(`停止发言请求失败。`);
        });
    },
    handleRemove(id) {
      removeQa(id)
        .then(() => {})
        .catch(error => {
          console.log(error);
          this.$message.error(`移出问答请求失败。`, 1);
        });
    },
    handleStopQa() {
      stopQa()
        .then(() => {
          this.$store.commit("clearQa");
        })
        .catch(error => {
          console.log(error);
          this.$message.error(`关闭问答请求失败。`, 1);
        });
    },
    handleMoveUpQa(id) {
      moveUpQa(id)
        .then(() => {})
        .catch(error => {
          console.log(error);
          this.$message.error(`移出问答请求失败。`, 1);
        });
    },
    handleMoveTopQa(id) {
      moveTopQa(id)
        .then(() => {})
        .catch(error => {
          console.log(error);
          this.$message.error(`移出问答请求失败。`, 1);
        });
    }
  }
};
</script>
<style lang="less" scoped>
.order-btn {
  .order-btn-item {
    cursor: pointer;
    margin-right: 18px;
    &:last-child {
      margin-right: 0px;
    }
  }
}
</style>
<style lang="less">
.qa-list-container {
  flex: 1;
  flex-direction: column;
  display: flex;
  overflow: hidden;
  padding: 24px 40px 0 40px;
  .qa-list-bar {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
    .qa-disable-button-icon {
      width: 24px;
      height: 24px;
    }
    & > span {
      font-size: 16px;
      letter-spacing: -0.18px;
      color: #333333;
    }
    .qa-list-bar-button {
      display: flex;
      align-items: center;
      width: 100px;
      height: 32px;
      border-radius: 2px;
      border: solid 1px #e5e5e5;
      background-color: #ffffff;
      cursor: pointer;
      .qa-list-bar-button-icon {
        width: 24px;
        height: 24px;
        margin-right: 4px;
      }
      &:focus {
        outline: none;
      }
      &:hover {
        outline: none;
        border: solid 1px fade(#000, 30%);
      }
      &:active {
        border: solid 1px fade(#000, 40%);
        background-color: #e5e5e5;
      }
    }
  }
  .qa-list-content-wrap {
    display: flex;
    flex: 1;
    overflow: auto;
    // flex-direction: column;
  }
  .qa-list-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    .qa-no-data {
      height: 600px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      svg {
        width: 160px;
        height: 120px;
      }
      span {
        color: rgba(0, 0, 0, 0.5);
      }
    }
    .ant-list-item {
      padding: 0;
    }
    .qa-list-content-title {
      width: 100%;
      height: 38px;
      background-color: #f4f4f4;
      display: flex;
      justify-content: space-around;
      align-items: center;
      // padding-left: 94px;
      &:first-child > span {
        text-align: left;
      }
      > span {
        // width: 33.33%;
        text-align: left;
        &.name {
          flex: 2;
          padding-left: 25px;
        }
        &.phone {
          flex: 1.5;
        }
        &.company {
          flex: 2;
        }
        &.department {
          flex: 2;
        }
        &.adjust-order {
          flex: 1;
        }
        &.operate {
          min-width: 210px;
          flex: 2;
        }
      }
    }
    .qa-list-content-item {
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-bottom: 1px solid #e3e7ed;
      // padding-left: 30px;
      height: 48px;
      // &:first-child > span {
      //   display: flex;
      //   align-items: center;
      //   text-align: left;
      // }
      > span {
        // width: 33.33%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        &.name {
          display: flex;
          flex: 2;
          padding-left: 25px;
          .name-text {
            display: inline-block;
            max-width: calc(100% - 72px);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        &.phone {
          flex: 1.5;
        }
        &.company {
          flex: 2;
        }
        &.department {
          flex: 2;
        }
        &.adjust-order {
          flex: 1;
        }
        &.operate {
          min-width: 210px;
          flex: 2;
        }
      }
      .item-arrow {
        // display: inline-block;
        // width: 50px;
        i {
          margin-right: 10px;
          cursor: pointer;
        }
      }
      .qa-list-talk-button {
        margin-right: 17px;
        font-size: 13px;
        border-radius: 2px;
        color: #333333;
        &:hover {
          outline: none;
          border: solid 1px fade(#000, 40%);
          background-color: fade(#fff, 80%);
          color: #333333;
        }
        &:active {
          color: #333333;
          border: solid 1px fade(#000, 40%);
          background-color: fade(#000, 30%);
        }
        &:focus {
          outline: none;
          color: #333333;
          border-color: #e5e5e5;
        }

        &:after {
          border: 0 none;
          opacity: 0;
          animation: none 0 ease 0 1 normal;
        }
      }

      .qa-list-no-talk-button {
        color: red !important;
        border: solid 1px red !important;
      }
      .qa-list-quit-button {
        border: none;
        &:active,
        &:focus,
        &:hover {
          border: none;
          outline: none;
          color: rgba(0, 0, 0, 0.65);
        }
      }
      .qa-list-quit-button {
        border: none;
      }
    }

    .qa-list-talk-icon {
      width: 22px;
      height: 22px;
      &.talk {
        width: 18px;
        height: 18px;
      }
    }
  }
}
</style>
